import * as React from 'react';
import { SVGProps } from 'react';

const IconPanelBottomSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M19 13H5v3h14v-3z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 5h20v14H2V5zm2 2h16v10H4V7z"
    />
  </svg>
);
export default IconPanelBottomSizeM;
